import axios from "./api";
class UserService {
  getAll() {
    return axios.get(`/users`);
  }
  get(id) {
    return axios.get(`/users/${id}`);
  }
  create(data) {
    return axios.post(`/users`, data);
  }
  update(id, data) {
    return axios.put(`/users/${id}`, data);
  }
  delete(id) {
    return axios.delete(`/users/${id}`);
  }
  // deleteAll() {
  //     return http.delete(`/requesting`);
  // }
  // findByTitle(titre) {
  //     return http.get(`/requesting?titre=${titre}`);
  // }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new UserService();
